import { useIsNodeStaff } from "@js/apps/common/hooks";
import { useIsEmployerImpersonated } from "@js/apps/jobs/hooks/employer-impersonated-session";

export const useCanManageJobsOnBehalfOfClient = () => {
  const isNodeStaff = useIsNodeStaff();
  const isEmployerImpersonated = useIsEmployerImpersonated();

  return isNodeStaff || isEmployerImpersonated;
};
